import { Link, type LinkProps } from 'react-router';

import styles from './ui.module.css';

export interface LinkButtonProps extends LinkProps {
  variant?: 'default' | 'primary';
}

/** A navigation link that looks like a button, for the main action of a screen. */
export function LinkButton({
  variant = 'default',
  className,
  ...rest
}: LinkButtonProps): React.JSX.Element {
  const classes = [
    styles.button,
    styles.link,
    variant === 'primary' ? styles.primary : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <Link className={classes} {...rest} />;
}
